import React, { FC, useEffect, useState } from 'react';

import MonthlyBillingCard from '@components/charts/telecom/MonthlyBillingCard';
import { useTranslation } from 'react-i18next';
import { useSelector } from 'react-redux';
import LoadingSpinner from '../../../components/buttons/LoadingSpinner';
import { SimcardService } from '../../../services/simcards/Simcards';
import { RootState } from '../../../state/store';

type SimUsage = {
  props: {
    phoneNumbers: string[];
  };
};

const SimUsagePerUser: FC<SimUsage> = ({ props }) => {
  const { t } = useTranslation();
  const service = new SimcardService();
  const [usage, setUsage] = useState([]);
  const [params, setParams] = useState(props);
  const companyId = useSelector(
    (state: RootState) => state.companies.selectedCompany?.id
  );
  useEffect(() => {
    if (companyId) {
      try {
        service.getUsagePerUser(params, companyId).then((response) => {
          setUsage('results' in response ? response.results : response);
        });
      } catch (err) {
        console.error('Error fetching SIM data:', err);
      }
    }
  }, [companyId]);

  return (
    <>
      {usage.length > 0 ? (
        <MonthlyBillingCard
          data={{ results: usage, limit: 0, offset: 0 }}
          showDetails={false}
        />
      ) : (
        <LoadingSpinner />
      )}
    </>
  );
};
export default SimUsagePerUser;
